import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const quoteDataClassName = DataClassName.QUOTE
const quoteEndpoint = PisaDataClassEndpoint.QUOTE

export function pisaQuoteDataClass(attributes: DataAttributeDefinitions) {
  return provideDataClass(quoteDataClassName, {
    title: quoteDataClassName,
    restApi: createPisaRestApiConfig(quoteEndpoint),
    attributes,
  })
}
